var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(-1360 -2738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M43,48H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H43a5.006,5.006,0,0,1,5,5V43A5.006,5.006,0,0,1,43,48ZM11,9.142h0l2.367,26.7,10.6,3.019,10.663-3.018L37,9.142H11ZM24,33.023h0l-6.766-2.109-.359-4.773h3.232l.233,2.612,3.659,1,3.6-1,.454-4.362H20.4l-.3-3.185h8.221l.316-3.362-12.535,0L15.841,14.6l16.318,0L30.652,31.128,24,33.023Z",
    transform: "translate(1360 2738)",
    fill: "#ffb400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M43,48H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H43a5.006,5.006,0,0,1,5,5V43A5.006,5.006,0,0,1,43,48ZM11,9.142h0l2.367,26.7,10.6,3.019,10.663-3.018L37,9.142H11ZM24,33.023h0l-6.766-2.109-.359-4.773h3.232l.233,2.612,3.659,1,3.6-1,.454-4.362H20.4l-.3-3.185h8.221l.316-3.362-12.535,0L15.841,14.6l16.318,0L30.652,31.128,24,33.023Z",
    transform: "translate(1360 2738)",
    fill: "#ffb400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/CSS.a493798a4a38166ff414f54ab2fb2bdb.svg";
export { ForwardRef as ReactComponent };